export default "__VITE_ASSET__WpwNEi2x__"